// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"404":"73fdca17","837":"5f1a4b8a"}[chunkId] + ".chunk.css";
};